import { Modal } from "antd";

export const showDeleteConfirm = (onConfirm) => {
  Modal.confirm({
    title: "Are you sure you want to delete?",
    content: "This action cannot be undone.",
    okText: "Delete",
    cancelText: "Cancel",
    okType: "danger",
    centered: true,
    okButtonProps: {
      className: "custom-modal-btn custom-delete-btn",
    },
    cancelButtonProps: {
      className: "custom-modal-btn custom-cancel-btn",
    },
    onOk: onConfirm,
  });
};